import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class JobApplicationService {

  constructor(private http: HttpClient) { }

  // =========================
  // Helpers
  // =========================

  private buildParams(filters: any = {}): HttpParams {
    let params = new HttpParams();

    Object.keys(filters).forEach(key => {
      if (
        filters[key] !== null &&
        filters[key] !== undefined &&
        filters[key] !== ''
      ) {
        params = params.set(key, filters[key]);
      }
    });

    return params;
  }

  private buildFormData(data: any = {}): FormData {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
      const value = data[key];

      if (
        value !== null &&
        value !== undefined &&
        value !== ''
      ) {
        formData.append(key, value);
      }
    });

    return formData;
  }

  // =========================
  // Job Applications
  // =========================

  getJobApplications(filters: any = {}): Observable<any> {
    const params = this.buildParams(filters);

    return this.http.get(`${environment.Server_URL}/job-applications`, { params });
  }

  getJobApplication(id: any): Observable<any> {
    return this.http.get(`${environment.Server_URL}/job-applications/${id}`);
  }

  applyToJob(data: any): Observable<any> {
    const formData = this.buildFormData(data);

    return this.http.post(`${environment.Server_URL}/job-applications`, formData);
  }

  adminApplyForDoctor(data: any): Observable<any> {
    const formData = this.buildFormData(data);

    return this.http.post(`${environment.Server_URL}/job-applications/admin-apply`, formData);
  }

  updateApplicationStatus(id: any, data: any): Observable<any> {
    return this.http.patch(`${environment.Server_URL}/job-applications/${id}/status`, data);
  }

  deleteJobApplication(id: any): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/job-applications/${id}`);
  }

  // =========================
  // Applications By Job
  // =========================

  getApplicationsByJobId(jobId: any, filters: any = {}): Observable<any> {
    const params = this.buildParams(filters);

    return this.http.get(`${environment.Server_URL}/jobs/${jobId}/applications`, { params });
  }

  // =========================
  // Shortcuts
  // =========================

  getPendingApplications(page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('status', 'pending')
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/job-applications`, { params });
  }

  getReviewedApplications(page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('status', 'reviewed')
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/job-applications`, { params });
  }

  getShortlistedApplications(page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('status', 'shortlisted')
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/job-applications`, { params });
  }

  getAcceptedApplications(page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('status', 'accepted')
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/job-applications`, { params });
  }

  getRejectedApplications(page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('status', 'rejected')
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/job-applications`, { params });
  }

  getCancelledApplications(page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('status', 'cancelled')
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/job-applications`, { params });
  }

  getApplicationsByDoctorId(doctorId: any, page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('doctor_id', doctorId)
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/job-applications`, { params });
  }

  getApplicationsByUserId(userId: any, page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('user_id', userId)
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/job-applications`, { params });
  }

  getApplicationsByJobAndStatus(jobId: any, status: string, page: any = 1): Observable<any> {
    const params = new HttpParams()
      .set('status', status)
      .set('page', page);

    return this.http.get(`${environment.Server_URL}/jobs/${jobId}/applications`, { params });
  }
  publicApplyToJob(data: any): Observable<any> {
  const formData = this.buildFormData(data);

  return this.http.post(
    `${environment.Server_URL}/job-applications/public-apply`,
    formData
  );
}

}